import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=fb526568&scoped=true"
import script from "./Footer.vue?vue&type=script&setup=true&lang=ts"
export * from "./Footer.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Footer.vue?vue&type=style&index=0&id=fb526568&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb526568",
  null
  
)

export default component.exports